import gqls from "@/graphql/Imports.gql";

// callback 调用
import { resRest, easyMutate } from "@root/lib/utils";

import BbqActions from "@root/lib/bbqActions";
// console.log(Object.assign(gqls, getAttr), "Object.assign(gqls, getAttr)");
const shortAction = new BbqActions(gqls, []);
const gqlActions = shortAction.getValues();

const tags = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    ...gqlActions
  },
  mutations: {
    easyMutate
  }
};
export default tags;
